/* eslint-disable no-shadow */
const state = {
	topSellingProducts: []
}

const getters = {
	getTopSellingProducts: state => state.topSellingProducts
}

const mutations = {
	setTopSellingProductsMutation: (state, payload) => {
		const product = state.topSellingProducts
			.filter(topSellingProducts => topSellingProducts.product_id === payload.product_id)
		if (product.length === 0) {
			state.topSellingProducts.push(payload)
		}
	},

	clearTopSellingProductsMutation: (state) => {
		state.topSellingProducts = []
	}
}

const actions = {

	setTopSellingProductsData: ({
		commit
	}, payload) => {
		commit('setTopSellingProductsMutation', payload)
	},

	clearTopSellingProductsData: ({
		commit
	}, payload) => {
		commit('clearTopSellingProductsMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
